import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize16 {
  size: '16';
}
type OverrideIconSize = OverrideIconSize16;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '16') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.5 2.5C9.22386 2.5 9 2.72386 9 3C9 3.27614 9.22386 3.5 9.5 3.5H11.7899L7.58157 7.70832C7.42536 7.86453 7.42536 8.11779 7.58157 8.274L7.72299 8.41543C7.8792 8.57164 8.13246 8.57164 8.28867 8.41543L12.5 4.2041V6.5C12.5 6.77614 12.7239 7 13 7C13.2761 7 13.5 6.77614 13.5 6.5V3C13.5 2.72386 13.2761 2.5 13 2.5H9.5ZM3.19995 3.70001C3.19995 3.42387 3.42381 3.20001 3.69995 3.20001H6.27773C6.55387 3.20001 6.77773 3.42387 6.77773 3.70001C6.77773 3.97615 6.55387 4.20001 6.27773 4.20001H4.19995V12.6H12.4V9.14212C12.4 8.86597 12.6238 8.64212 12.9 8.64212C13.1761 8.64212 13.4 8.86597 13.4 9.14212V13.1C13.4 13.3762 13.1761 13.6 12.9 13.6H3.69995C3.42381 13.6 3.19995 13.3762 3.19995 13.1V3.70001Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 16 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'event');
export default IconComponent;
